// extracted by mini-css-extract-plugin
export default {"spaceAlignContainer":"AddUser_spaceAlignContainer__p3ruf"};